var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.6665H13V13.6665H17V11.6665H13V7.6665H11V11.6665H7V13.6665H11V17.6665ZM12 22.6665C10.6167 22.6665 9.31667 22.4038 8.1 21.8785C6.88334 21.3532 5.825 20.6408 4.925 19.7415C4.025 18.8422 3.31267 17.7838 2.788 16.5665C2.26333 15.3492 2.00067 14.0492 2 12.6665C1.99933 11.2838 2.262 9.98384 2.788 8.7665C3.314 7.54917 4.02633 6.49084 4.925 5.5915C5.82367 4.69217 6.882 3.97984 8.1 3.4545C9.318 2.92917 10.618 2.6665 12 2.6665C13.382 2.6665 14.682 2.92917 15.9 3.4545C17.118 3.97984 18.1763 4.69217 19.075 5.5915C19.9737 6.49084 20.6863 7.54917 21.213 8.7665C21.7397 9.98384 22.002 11.2838 22 12.6665C21.998 14.0492 21.7353 15.3492 21.212 16.5665C20.6887 17.7838 19.9763 18.8422 19.075 19.7415C18.1737 20.6408 17.1153 21.3535 15.9 21.8795C14.6847 22.4055 13.3847 22.6678 12 22.6665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuExpand);
export default __webpack_public_path__ + "static/media/menu-expand.da5d1ff6c9be3912c1f2f00259144a6e.svg";
export { ForwardRef as ReactComponent };